var emailverifybuffer = new Object();

function getClientTimezone(date) { 
  return /\((.*)\)/.exec(date.toString())[1];
}

$(document).ready(function() {
	
	$('.try-result-page .flippCard').on('click', function(){
			
		pSendGAEvent('pt_cta_click', {'pt_cta_id': 'applythankyou-linkedinfollow-card-flipped'}, 'apply.js', 'applythankyou-linkedinfollow send event gone wrong');	
								
		if(!$(this).hasClass('flipped')) {
			$(this).addClass('flipped');
			$(this).find('.back').append("<script src=\"https://platform.linkedin.com/in.js\" type=\"text/javascript\"> lang\: en\_US\<\/script><script type=\"IN/FollowCompany\" data-id=\"3149560\" data-counter=\"bottom\">\<\/script>");
		}
		
	});

	var getTimezone = function (){
	
		if($('#impactit_timezone').length > 0){
			
			var date = new Date();
			$dateString = date.getFullYear()+'-'+pad((date.getMonth()+1),2)+'-'+pad(date.getDate(),2)+' '+pad(date.getHours(),2)+':'+pad(date.getMinutes(),2)+':'+pad(date.getSeconds(),2);
				
			$.ajax({
				type: 'POST',
				url: '/apply/getTimezone',
				data: { 
					clienttimeoffset: new Date().getTimezoneOffset()*-1,
					clientDate: $dateString ,
					clienTimezone: getClientTimezone(date)
				},
				cache: false,
				success: function(result) {
					obj = JSON.parse(result);
					$('#impactit_timezone').val(obj.result);
				}
			});
			
		}
	};
	
	function pad(num, size) {
    var s = num+"";
    while (s.length < size) s = "0" + s;
    return s;
	}
	
	var initValidation = function() {
		
		/**
		 * Validation. See http://bassistance.de/jquery-plugins/jquery-plugin-validation 
		 */
		if (ptData.form_stage == 'form') { 
			
			var myFormValidator = null;
			
			var rules = ptData.form_validation_rules;

			// augment client-side parts of the rules
			rules.emailaddress1.remote = {
						url: '/apply/verifyEmail',
						timeout: 9500,
						data : {
							language: ptCommon.language
						},
						error: function(jqXHR, textStatus, errorThrown) {
							$('#emailaddress1').rules('remove','remote');
							if (myFormValidator != null) {
								myFormValidator.pendingRequest--;
								myFormValidator.element('#emailaddress1');
							}
							console.log('AJAX verification error: ' + textStatus);
						},
						beforeSend: function(jqXHR, settings) {
							$('#emailaddress1').addClass('verifyanim');	
							$("#Absenden").addClass('button-disabled');
						},
						complete: function(jqXHR, textStatus) {
							$('#emailaddress1').removeClass('verifyanim');
							$("#Absenden").removeClass('button-disabled');
						}
			};

			myFormValidator = $("#portatour-trial-form").validate({
				errorClass: "errorfield",
				validClass: "validfield",
				onfocusout : function(element, event) { var val = $(element).val(); val = val.trim();$(element).val(val); $(element).valid(); }, 
				onkeyup : false, // on form1, nothing needs to be validated on keyup. the email address is remote-validated, causing cost on every call
				rules: rules,
				submitHandler: function(form) {
					// submit button					
					$("#Absenden").addClass('button_loading');
					$('#Absenden').prop('disabled', 'disabled'); // FS#19014 essential, MUST NOT BE REMOVED
					window.setTimeout(function(){ 
						//FS#10476
						var value = $('#emailaddress1').val(); 
						value = value.trim();	
						$('#emailaddress1').val(value);
						form.submit();
					},	10);
				},
				success: function(e){
					e.closest("p").removeClass("hasError");
				},
				
				errorPlacement: function(error,element){
					// place after the label, not the input
					element.closest("p").addClass("hasError");
					if($(element).hasClass("applycheck")) {
						error.appendTo( element.closest("p").find("label"));
					}else {
						// place after input
						error.appendTo( $(element).parent() );
					}
					
				}
			});
		} 
		
		if (ptData.form_stage == 'formdetails') { 
			
			var rules = ptData.form_validation_rules;
			
			/*FS#13701*/
			jQuery.validator.addMethod('brPhone', 
				function(value) { 
					return (value.replace(/[^0-9]/g,"").length > 9); 
				},pLang__('brPhoneErrorMessage')
			);
			
			rules.telephone1.brPhone = {
				depends: function(element) {
					return $('#address1_country').val() == "BR";
				},
			};
						
			$("#portatour-trial-form").validate({
				errorClass: "errorfield",
				validClass: "validfield",
				onfocusout : function(element, event) { var val = $(element).val(); val = val.trim();$(element).val(val); $(element).valid(); },
				rules: rules,
				submitHandler: function(form) {
					// remove form changed warning
					window.onbeforeunload='';
					window.pformchanged=false;
					
					// submit animation
					$("#Absenden").addClass('button_loading');
					$('#Absenden').attr('disabled','disabled'); // FS#19014 essential, MUST NOT BE REMOVED
					$("#loadinganim").show();
					window.setTimeout(function(){ 
						// $('#Absenden').attr('disabled',''); // FS#19014 essential: we must not enable it again
						form.submit(); 
					},	10);
					
				}
			});
			
			window.pformchanged = true;
			window.onbeforeunload=function(){
				if(window.pformchanged){
					return pLang__('applyunload');
				}
			};

		}
		// is this a postback? then show all the validation you can
		if (ptData.ispostback)
			$("#portatour-trial-form").valid();


		// checks if element is invalid
		// if so, add error class to the wrapping p tag
		function checkForErrorClass(e) {
			var valid = $(e).valid();
			if(!valid){
				$(e).closest("p").addClass("hasError");
			}else {
				$(e).closest("p").removeClass("hasError");
			}
		}		
		
		$('span.boxhelper').on('click', function(e) {
			$(this).closest("p").find('label.boxlabel').first().trigger('click');
			// in IE11 the onclick event handler of the validation plugin is not being called when you manually trigger a 
			// click on the corresponding label. therefore we need our own function to call 
			checkForErrorClass("#"+$(this).closest("p").find('input').first().attr("id"));
		});

		$('p.checkelem input').on('change', function(e){
			checkForErrorClass("#"+$(this).attr("id"));
		});
	};
	
	// init validator if not android-prefilled
	// if (!ptData.ptForAndroidPrefilled) 
		initValidation();
		getTimezone();

	// Loading Animaton for Android-Prefilled-Button
	if (ptData.ptForAndroidPrefilled) {
		var btnPrefilled = $('#firstpage-androidprefilled button[type=submit]');
		if (btnPrefilled.length) {		
			$("#portatour-trial-form").on('submit', function(e) {
				btnPrefilled.addClass('button_loading');
				btnPrefilled.attr('disabled','disabled');
			});
		}		
	}
	
	/**
	 * https://gist.github.com/alex-gist/2025270, 
	 * LS: with the adaptation of only first-letter when only one letter typed 
	 * used at the /shop and at /apply
	 */
	$('.upperfirst').on('blur', function(event) {
		var textBox = $(event.target);
		if (1 == textBox.data('upperfirsted'))
			return;
		var v = textBox.val();
		if (''==v)
			return;
		v = v.charAt(0).toUpperCase() + v.slice(1);
		textBox.val(v);
		textBox.data('upperfirsted', 1);
	});
	
	
	/**
	 * FS#11012 special offer
	 */
    (function () {
        var formatWithTowDigits = function (value) {
            return (value < 10 ? "0" : "") + value.toString();
        };
        var formatDateFallback = function (date) {
            return date.getFullYear().toString() + "-" + formatWithTowDigits(date.getMonth() + 1) + "-" + formatWithTowDigits(date.getDate());
        };
        var from = new Date();
        var to = new Date(from.getTime());
        to.setHours(24, 0, 0, 0);
        var millis = to.getTime() - from.getTime();
        if (millis < 0) millis = 0;
        var totalMinutes = Math.round(millis / 1000 / 60);
        var hours = Math.floor(totalMinutes / 60);
        var minutes = totalMinutes % 60;

        var countdownEnd = from.toLocaleDateString ? from.toLocaleDateString() : formatDateFallback(from);
        $('#apply-specialoffer-countdown-end').html(countdownEnd);
        $('#apply-specialoffer-countdown-h').html(hours);
        $('#apply-specialoffer-countdown-m').html(minutes);
    }());

    
	/**
	 * FS#16424 - Apply: Android: Ablauf mit Rechtevergabe am Start: Logikänderung
	 * 
	 */
	if($('.androidPermsWrapper').length && typeof window.ptAndroidInterface != 'undefined' && typeof window.ptAndroidInterface.askForUserProfileData === 'function') {
		$('.androidPermsWrapper').removeClass('hideForAndroid');
		
		$('#autofillAndroidForm').on('click', function(event) {
					
			event.preventDefault();
			 	
			try {
				window.ptAndroidInterface.askForUserProfileData();
			} catch (e) {

				ptClientErrorLog({caller: 'apply.js:window.ptAndroidInterface', errorThrown: e }, 'apply-android');
				
			}
			return false;
		});
	} else {
		//for testing only
		//$('.androidPermsWrapper').removeClass('hideForAndroid');
	}
	
});


/**
 * On change of CRM Dropdown
 */
function selectCRMCallback(init) {
	var val = $('#selectcrm').val();
	$('input[name="product"]').val('anywhere');
	
	if(!init){
		// uncheck the admin checkboxes
		$('#testadmin').prop('checked', false);
		$('#testdynamics').prop('checked', false);
	}
	// when crm changes, reset the testdynamics check
	$('p.testdynamics').addClass('hidden');
	
	if(val == 'other' || val == '' || val == '-' || val == 'veeva' || val == 'salesforce'){
		// all cases but dynamics
		if(val == 'other'){
			$('#derzeitige-crm-software').removeClass("hidden");
			$('#derzeitige-label').removeClass("hidden");
		}
		else {
			$('#derzeitige-crm-software').addClass("hidden");
			$('#derzeitige-label').addClass("hidden");
		}

		$('p.isadmin').addClass('hidden');
	} else if (val == "dynamics-crm") {
		// dynamics crm
		$('p.isadmin').removeClass('hidden');
		$('#derzeitige-crm-software').addClass("hidden");
		$('#derzeitige-label').addClass("hidden");
	} else {
		ptClientErrorLog({'msg': '#selectcrm has unknown CRM ' + val, caller:'apply.js:selectCRMCallback'});
	}
	
	// when the isadmin checkbox is visible, trigger the change
	if(!$('p.isadmin').hasClass('hidden')) {
		$('#testadmin').trigger('change');
	}

}

function initApplyFormEvents() {
	//only init this these events if selectcrm is present in code
	if(typeof $('#selectcrm').val() !== 'undefined') {

		$('#selectcrm').on('change', function(e){
			selectCRMCallback(false);
		});


		$('#testadmin').on('change', function(e){
			if($(this).is(':checked')){
				var crmVal = $('#selectcrm').val();
				if(crmVal == "dynamics-crm"){
					$('p.testdynamics').removeClass('hidden');
				}
				if(crmVal == "salesforce"){
					$('p.testdynamics').addClass('hidden');
				}
			}else{
				$('p.testdynamics').addClass('hidden');
				$('#testdynamics').prop('checked',false);
				$('input[name="product"]').val('anywhere');
			}
			
		});

		$('#testdynamics').on('change',function(e){
			if($(this).is(':checked')){
				$('input[name="product"]').val('dynamics-crm');
			}else{
				$('input[name="product"]').val('anywhere');
			}
		});
		
		selectCRMCallback(true);
	}
}